import { inject } from '@angular/core';
import { Router, type ResolveFn } from '@angular/router';
import { BaseResponse } from '@models/common.model';
import { AuthService } from '@services/auth.service';
import { ToastService } from '@services/toast.service';
import { catchError, exhaustMap, from, map, Observable, of, switchMap } from 'rxjs';

export const accountVerificationResolver: ResolveFn<Observable<boolean>> = (route) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const toast = inject(ToastService);
    const token = route.queryParamMap.get('t');

    if (!token) {
        return from(router.navigate(['/'])).pipe(map(() => false));
    }

    return authService.session.pipe(
        exhaustMap((session) => {
            if (session) {
                toast.warn(
                    $localize`:@@account-verification.toast.already-logged-in.title:Cảnh báo`,
                    $localize`:@@account-verification.toast.already-logged-in.content:Vui lòng đăng xuất trước khi thực hiện xác thực tài khoản!`
                );
                return from(router.navigate(['/'])).pipe(map(() => false));
            }
            return authService.accountVerification(encodeURIComponent(token));
        }),
        catchError(() => of(new BaseResponse({ ID: -1 }))),
        switchMap((res) => {
            if (typeof res === 'object' && res.ID === 0) {
                toast.warn(
                    $localize`:@@account-verification.toast.account-verified.title:Thông báo`,
                    $localize`:@@account-verification.toast.account-verified.content:Tài khoản của bạn đã được xác thực trước đó. Hãy đăng nhập để tận hưởng các tính năng tuyệt vời của chúng tôi.`
                );
                return from(router.navigate(['/'])).pipe(map(() => false));
            }
            return of(res);
        }),
        map((res) => {
            return typeof res === 'object' && res.ID > 0;
        })
    );
};
